import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { KeyValue } from '../../types/common.types';
import { User } from '../../types/user.types';
import { CartOrder } from '../../types/shoppingCart.types';
import { ProductOrder } from '../../types/order';
import { Plan } from '../../types/plan.types';
import { Checkout } from '../../types/checkout.types';
import { Tracker } from '../../types/tracker';
import { Fulfilment } from '../../types/fulfilment.types';
import { LogState, pushUserJourney, resetLogs } from '../../reducers/logs';
import isFeatureFlagEnabled from '../../helpers/feature-flags';
import { FEATURE_FLAG_ENABLE_FE_LOG } from '../../types/featureFlag.types';

export const useTracker = location => {
  const {
    user,
    productOrder,
    fulfillment,
    checkout,
    plan,
    cartOrder,
    log
  } = useSelector((state: KeyValue) => ({
    user: state.user as User,
    productOrder: state.order?.productOrder as ProductOrder,
    fulfillment: state.fulfillment as Fulfilment,
    checkout: state.checkout as Checkout,
    plan: state.plan?.selectedPlan as Plan,
    cartOrder: state.cart?.order as CartOrder,
    log: state.log as LogState
  }));
  const dispatch = useDispatch();
  useEffect(() => {
    if (isFeatureFlagEnabled(FEATURE_FLAG_ENABLE_FE_LOG))
      dispatch(pushUserJourney(location.href));
  }, [location.href]);

  useEffect(() => {
    if (
      log?.shouldSendLog &&
      isFeatureFlagEnabled(FEATURE_FLAG_ENABLE_FE_LOG)
    ) {
      const logs = composeLogs();
      const { userJourney, apis, ...rest } = logs;
      console.log(
        `orderId: ${productOrder?.productOrderId} - userJourney`,
        userJourney
      );
      console.log(
        `orderId: ${productOrder?.productOrderId} - apis called`,
        apis
      );
      console.log(`orderId: ${productOrder?.productOrderId} - others`, rest);
      dispatch(resetLogs());
    }
  }, [log?.shouldSendLog]);

  function composeLogs(): Tracker | KeyValue {
    try {
      const { delivery } = fulfillment || {};
      return {
        error: log.error,
        browser: window?.navigator?.userAgent,
        order: {
          orderId: productOrder?.productOrderId
        },
        flowData: {
          flowType: productOrder?.type,
          isCis: !!user?.cis?.information,
          isOnePass: !!user?.information?.userDetails?.loginId
        },
        apis: log.apiLogs,
        userJourney: log.userJourney,
        device: {
          mainProduct: [
            {
              name: cartOrder?.mobile?.device?.name,
              sku: cartOrder?.mobile?.device?.sku,
              deviceProductID: cartOrder?.mobile?.device?.deviceProductID
            }
          ],
          freeGift: cartOrder?.mobile?.freebies,
          accessory: cartOrder?.accessories?.map(accessory => ({
            name: accessory.name,
            sku: accessory.skuId,
            accessoryId: accessory.accessoryId,
            productID: accessory.productID
          })),
          sim: cartOrder?.newlyAddedSimDetails?.simDetails
        },
        fulfilment: {
          selectedDeliveryMode: delivery?.selectedDeliveryMode,
          allocatedItems: fulfillment?.allocateOrReserve?.data,
          reservedItems: fulfillment?.allocateOrReserve?.reserveEquipmentData,
          deliveryAddressId:
            checkout?.newAddedAddressId ||
            delivery?.deliveryDetails?.contactAddress?.addressId
        },
        plan: {
          planName: plan?.planName,
          planId: plan?.planId,
          mecId: plan?.mecId,
          groupName: plan?.groupName
        }
      };
    } catch (e) {
      return {};
    }
  }
};
